import { render, staticRenderFns } from "./TenantLoginForm.vue?vue&type=template&id=708b145e&scoped=true&"
import script from "./TenantLoginForm.vue?vue&type=script&lang=js&"
export * from "./TenantLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b145e",
  null
  
)

export default component.exports